import { useSelector, useDispatch } from "react-redux";
import { saveSettings, getClubs, addClub } from "../../js/database";
import { setSettings } from "../../slices/databaseSlice";
import { useEffect } from "react";
import { getGCAuthURL } from "../../js/getHomework";
import { useState } from "react";
import { clubColors, timeString } from "../../js/generateSchedule";
import { saveLocalSettings } from "../../js/localDB";
import { useNavigate } from "react-router-dom";
import { AddMeeting } from "./Club";
import { useGoogle } from "../../js/classroom";

function Settings() {
    const user = useSelector(state => state.user);
    const settings = useSelector(state => state.database.settings) 
    const classes = useSelector(state => state.database.classes);
    const [authLink, setAuthLink] = useState("")
    const [clubs, setClubs] = useState({})
    const [gcCourses , setGcCourses] = useState([]);
    const [classNames, setClassNames] = useState([])
    // const google = useGoogle();
    // console.log(google);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        
        if (settings.hasOwnProperty("gcconfig")) {
            // fetch("/api/gc/listCourses?token="+settings.gcconfig.refresh_token).then((res) => res.json().then((data) => {
            //     setGcCourses(data);
            //     Object.values(classes).forEach((c) => {
            //         if (c.id !== null) {
            //             setClassNames((classNames) => {
            //                 if (classNames.includes(c.id)) return classNames;
            //                 classNames.push(c.id);
            //                 return classNames;
            //             })
            //         }
            //     })
            // }))
        } else {
        // getGCAuthURL().then((url) => {
        //     setAuthLink(url);
        // })
        console.log("no gcconfig")
    }

    getClubs().then(setClubs)
    }, []);
    
    return (
        <div class="modal fade" id="settings" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
<div class="modal-dialog">
<div class="modal-content bg-dark">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Settings</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <form onSubmit={handleSubmit}>
      <div class="settings">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" name="tname" value="true" id="flexSwitchCheckChecked" defaultChecked={settings.tname} />
        <label class="form-check-label" for="flexSwitchCheckChecked">Display Teacher Name</label>
      </div>
      <div class="form-check form-switch">
    <input class="form-check-input" type="checkbox" name="rnumber" value="true" id="flexSwitchCheckDefault" defaultChecked={settings.rnumber}/>
    <label class="form-check-label" for="flexSwitchCheckDefault">Display Room Number</label>
  </div>
  <div class="form-check form-switch">
<input class="form-check-input" type="checkbox" name="period" value="true" id="flexSwitchCheckDefault" defaultChecked={settings.period}/>
<label class="form-check-label" for="flexSwitchCheckDefault">Display Period</label>
</div>
<div class="form-check form-switch">
<input class="form-check-input" type="checkbox" name="pe" value="true" id="flexSwitchCheckDefault" defaultChecked={settings.pe}/>
<label class="form-check-label" for="flexSwitchCheckDefault">PE Exemption</label>
</div>
<div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" name="wschedule" value="true" id="flexSwitchCheckDefault" defaultChecked={settings.wschedule} />
  <label class="form-check-label" for="flexSwitchCheckDefault">Display Whole Schedule</label>
  </div>
  <div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" name="coverride" value="true" id="flexSwitchCheckDefault" defaultChecked={settings.coverride} />
  <label class="form-check-label" for="flexSwitchCheckDefault">Clubs Override Letter Blocks</label>
  </div>
  <div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" name="fcycle" value="true" id="flexSwitchCheckDefault" defaultChecked={settings.fcycle} />
  <label class="form-check-label" for="flexSwitchCheckDefault">Display Full Cycle</label>
  </div>
  </div>
<div class="mb-3 homework-link">
    <label for="exampleInputEmail1" class="form-label">Assignment Webcal URL:</label>
    <input type="text" class="form-control" name="homework" id="exampleInputEmail1" aria-describedby="emailHelp" defaultValue={settings.homework}/>
    <div id="emailHelp" class="form-text">Get this by clicking the rotated wifi symbol on the Calender page of the Parker Portal. Once in the menu right-click Assignments and select "Copy Link Address" </div>
  </div>
  {/* {settings.hasOwnProperty("gcconfig") ?
  classNames.map((c) => (
    <div class="form-group">
  <label for="sel1">{c.split(" ").slice(0, -1).join(" ")}</label>
  <select name={c} class="form-control" id="sel1" defaultValue={settings.gcconfig.hasOwnProperty("courses") && settings.gcconfig.courses[c]}>
    <option>Portal</option>
    {Object.entries(gcCourses).map(([courseId, courseName]) => (
        <option value={courseId}>{courseName}</option>
    ))}

    
  </select>
</div>
  ))
:
  <a href="#" onClick={google.getAuth}>Connect To Google Classroom</a>} */}
<div class="flexes">
<h3>Use Flex?</h3>
<p>Currently all flexes are shown because they appear to be required.</p>
{Object.entries(classes).map(([c, v]) => (
  c.length === 1 &&
  <div class="form-check form-switch">
    <input class="form-check-input" type="checkbox" name={"flex-"+c} value="true" id="flexSwitchCheckDefault" defaultChecked={v.params && v.params.flex} disabled={true} />
    <label class="form-check-label" for="flexSwitchCheckDefault">{c}</label>
  </div>
))}
</div>
<div class="club-settings">
<h3>Clubs</h3>
{Object.entries(clubs).map(([clubName, club]) => (
  (!club.pending || club.owner === user.uid) &&
  <div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" name={"club-"+clubName.replaceAll(" ", "_")} value="true" id="flexSwitchCheckDefault" defaultChecked={settings.hasOwnProperty("clubs") && settings.clubs[clubName]} />
  <label class="form-check-label" for="flexSwitchCheckDefault">{club.pending? clubName + " (Pending)" : clubName}</label>
  { club.owner === user.uid && <div>
    <table class="table">
  <thead>
    <tr>
      <th scope="col">Type</th>
      <th scope="col">Day</th>
      <th scope="col">Time</th>
    </tr>
  </thead>
  <tbody>

    {club.meetings && Object.values(club.meetings).map((m) => (
      <tr>
      <td>{m.type === "weekly"? "Weekly" : m.type === "cyclic" ? "Cyclic" : "One Time"}</td>
      <td>{m.type === "weekly"? ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"][m.day]: m.type === "cyclic" ? "Day "+(m.day+1) : m.day}</td>
      <td>{timeString([m.time.start, m.time.end])}</td>
      
    </tr>
    ))}
      </tbody>
      </table>
    <a href="#" data-bs-toggle="collapse" data-bs-target={"#"+clubName.replaceAll(" ", "_")} aria-expanded="false" aria-controls="collapseExample">Add Meeting</a>
    <div class="collapse" id={clubName.replaceAll(" ", "_")}>
  <AddMeeting clubName={clubName}/>
</div>
    </div>
    }
  </div>
))}
<a href="#" data-bs-toggle="modal" data-bs-target="#addClub">Add Club</a>
</div>
  <div class="d-flex justify-content-between">
  <button class="btn btn-danger mt-4" type="button" data-bs-dismiss="modal">Cancel</button><button class="btn btn-primary mt-4" type="submit" data-bs-dismiss="modal">Save</button></div>
  </form>

</div>
</div>
</div>

</div>
    )

    function handleSubmit(e) {
        e.preventDefault();
        var data = JSON.parse(JSON.stringify(settings));
        for (let i = 0; i < e.target.length; i++) {
            if (e.target[i].name === "") continue;
            if (e.target[i].type === "checkbox") {
              if(e.target[i].name.startsWith("club-")) {
                if (!data.hasOwnProperty("clubs")) data.clubs = {};
                data.clubs[e.target[i].name.split("-")[1].replaceAll("_", " ")] = e.target[i].checked;
              } else if (e.target[i].name.startsWith("flex-")) {
                if (!data.hasOwnProperty("flex")) data.flex = {};
                data.flex[e.target[i].name.split("-")[1]] = e.target[i].checked;
              } else {
                data[e.target[i].name] = e.target[i].checked;
              }
            } else if (e.target[i].type === "select-one") {
                if (!data.gcconfig.hasOwnProperty("courses")) data.gcconfig.courses = {};
                data.gcconfig.courses[e.target[i].name] = e.target[i].value;
            } else {
                console.log(e.target[i].name, e.target[i].type);
                if (e.target[i].name === "homework") e.target[i].value = e.target[i].value.replace("webcal://", "https://");
                data[e.target[i].name] = e.target[i].value;
            } 
        }
        if (settings.hasOwnProperty("local")) {
          saveLocalSettings(data);
          dispatch(setSettings(data));
        } else {
        saveSettings(user.uid, data).then(() => {
            dispatch(setSettings(data));
        })
      }
      navigate(0);
    }
}

export default Settings;